module.exports = __webpack_public_path__ + "img/qr.27296f5e.png";